// const BASE_URL = "https://api.maven-technologies.com/";
// const base_files_url = "https://staging.maven-technologies.com/";

const BASE_URL = "https://api.maventradingcrm.com/";
const base_files_url = "https://maventradingcrm.com/";

// const BASE_URL = "http://43.229.227.26:81/MavenCRM/";
// const base_files_url = "http://43.229.227.26:81/Maven-CRM/";

// const BASE_URL = "http://43.229.227.18:81/MavenCRM/";
// const base_files_url = "http://43.229.227.18:81/Maven-CRM/";


export const environment = {
  production: true,
  api_url: BASE_URL + "api",
  app_profile_path: BASE_URL + "Uploads/User_Doc/",
  app_temp_path: BASE_URL + "Uploads/User_Doc/Thumbnail/",
  app_download_path: BASE_URL,
  app_downpath: BASE_URL + "Uploads/Company/",
  app_path: BASE_URL,
  user_profile_img: base_files_url + "assets/images/users/default-user.png",
  default_temp: base_files_url + "assets/images/users/images.png",
  tempimage: BASE_URL,
  showmore: base_files_url + "assets/images/Arrow_Down_Show_More.svg",

  //Ashutosh
  orderDownloadPath: BASE_URL + "Uploads/OrderOverview/",
  approveDownloadPath: BASE_URL + "Uploads/OrderOverview/pdf/",
  upload_image_url: base_files_url + "assets/images/",
  upload_file_icon: base_files_url + "assets/images/file_icons/",
  upload_file_format: base_files_url + "assets/images/format/",
  import_sample: BASE_URL + "uploads/Excel/",
  default_img: BASE_URL + "Content/Image/no-image.png",
  // profile_img : "https://api.maven-technologies.com/",
  ProcurementPdfDownloadPath: BASE_URL + "Uploads/Procurement/Pdf/",
  ProcurementDownloadPath: BASE_URL + "Uploads/Procurement/",
  upload_user_file: base_files_url + "assets/images/",
  upload_user_fileIcon: base_files_url + "assets/images/file_icons/",
  // api_url: "http://43.229.227.26:81/MavenCRM/api",
  // app_profile_path: "http://43.229.227.26:81/MavenCRM/Uploads/User_Doc/",
  // app_temp_path: "http://43.229.227.26:81/MavenCRM/Uploads/User_Doc/Thumbnail/",
  // app_download_path :"http://43.229.227.26:81/MavenCRM/",
  // app_downpath  :"http://43.229.227.26:81/MavenCRM/Uploads/Company/",
  // app_path: "http://43.229.227.26:81/MavenCRM/",
  // user_profile_img: "https://maventradingcrm.com/assets/images/users/default-user.png",
  // default_temp : "https://maventradingcrm.com/assets/images/users/images.png",
  // tempimage:"http://43.229.227.26:81/MavenCRM/",
  // showmore:"https://maventradingcrm.com/assets/images/Arrow_Down_Show_More.svg"
};

// https://demoprojects.itsabacus.net/Maven_development

// http://43.229.227.26:81/Maven-CRM
